import { AuthService } from './authService';
import { LocationHeatmapRequest, LocationHeatmapDto } from '../components/warehouse/modules/location-heatmap/types';
import { extractApiError } from '../utils/apiError';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class LocationHeatmapService {
  
  /**
   * Get location heatmap analysis
   */
  async getHeatmapAnalysis(request: LocationHeatmapRequest): Promise<LocationHeatmapDto[]> {
    const response = await AuthService.authenticatedPost(
      `${API_BASE_URL}/location-heatmap/analyze`,
      request
    );
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(extractApiError(errorData, response, 'Failed to get heatmap analysis'));
    }
    
    return await response.json();
  }
}

export const locationHeatmapService = new LocationHeatmapService();
